/* eslint-disable global-require */
const axios = require('axios')

exports.report = async uuid => {
  const URL = `https://notification.manyconvert.com/qrcode/notifications/${uuid}`

  const getReport = await axios.get(URL, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(resp => resp.data)

  console.log('retorno: ', getReport)
  return getReport
}

exports.getInstance = async uuid => {
  console.log(uuid)
  const URL = `https://notification.manyconvert.com/instance/${uuid}`
  console.log(URL)
  const Instance = await axios.get(URL)

  return Instance.data
}
